import { DisplayGrid } from '../../components/Grid/DisplayGrid';
import { JButton } from '../../components/UI/JButton';
import JPanel from '../../components/UI/JPanel';
import { MultilineLabel } from '../../components/UI/MultilineLabel';
import { ItemLocation, ItemType } from '../../enums';
import { useAppSelector } from '../../hooks';
import { Item } from '../../components/Item';
import { DropZone } from '../../components/DropZone/DropZone';
import { toServer } from '../../util/ServerSocket';
import { getItemType, isItemType } from '../../resources/Items';
import { ArmoryFeedback, useArmoryAttempt } from './ArmoryFeedback';

const ENCHANT_TYPES = [ItemType.Weapon, ItemType.Belt, ItemType.Body, ItemType.Gloves, ItemType.Helm, ItemType.Shoes, ItemType.Ring, ItemType.Amulet];

export function Enchantment() {
  const item = useAppSelector((store) => store.inventory.items[store.inventory.locations[ItemLocation.Enchant]]);
  const stone = useAppSelector((store) => store.inventory.items[store.inventory.locations[ItemLocation.EnchantStone]]);
  const dragging = useAppSelector((state) => state.ui.dragging.item);

  const attempt = useArmoryAttempt('enchantGetInfo', 'enchantAttempt', item, stone);
  function onDrop(uid: string) {
    toServer('enchantSetItem', { uid, location: ItemLocation.Enchant });
  }
  function onDropStone(uid: string) {
    toServer('enchantSetItem', { uid, location: ItemLocation.EnchantStone });
  }
  return (
    <>
      <JPanel size={{ width: 373, height: 180 - 26 }} background="UIResource.Common.BigBG1">
        <JPanel
          className="single-container"
          size={{ width: 73, height: 115 }}
          position={{ x: 25, y: 10 }}
          background="UIResource.Common.BigBG3">
          <MultilineLabel size={{ width: 73, height: 20 }} position={{ x: 0, y: 2 }} text="Equipment" style={{ textAlign: 'center' }} />
          <DisplayGrid size={{ width: 2, height: 3 }} position={{ x: 5, y: 20 }}>
            {item === undefined && dragging !== null && ENCHANT_TYPES.includes(getItemType(dragging)) && (
              <DropZone onDrop={onDrop} location={ItemLocation.Enchant} />
            )}
            {item && <Item item={item} />}
          </DisplayGrid>
        </JPanel>

        <JPanel size={{ width: 23, height: 23 }} position={{ x: 165, y: 62 }} background="UIResource.Compose.Add" />

        <MultilineLabel
          size={{ width: 132, height: 20 }}
          position={{ x: 217, y: 30 }}
          text="Enchanting Stone"
          style={{ textAlign: 'center' }}
        />

        <JPanel
          className="single-container"
          size={{ width: 46, height: 46 }}
          position={{ x: 260, y: 50 }}
          background="UIResource.Common.BigBG3">
          <DisplayGrid size={{ width: 1, height: 1 }} position={{ x: 5, y: 5 }}>
            {stone === undefined && dragging !== null && isItemType(dragging, ItemType.Enchantment) && (
              <DropZone onDrop={onDropStone} location={ItemLocation.EnchantStone} />
            )}
            {stone && <Item item={stone} />}
          </DisplayGrid>
        </JPanel>

        <MultilineLabel
          size={{ width: 160, height: 37 }}
          position={{ x: 204, y: 100 }}
          text="ใช้หินเสริมเวทมนตร์ 1 ชิ้นต่อครั้ง"
          style={{ textAlign: 'center' }}
        />
        <ArmoryFeedback cost={attempt.info.cost} rate={attempt.info.rate} result={attempt.result} />
      </JPanel>

      <JButton
        size={{ width: 100, height: 22 }}
        position={{ x: 40, y: 185 - 26 }}
        text="Attempt"
        disabled={attempt.disabled}
        loading={attempt.loading}
        onClick={attempt.onAttempt}
      />
      <JButton size={{ width: 100, height: 22 }} position={{ x: 235, y: 185 - 26 }} text="Instructions" disabled />
    </>
  );
}
